import { Protocol } from '../Protocol';

export class FineRecordProtocol {
  public static readonly SearchRecord: string = `${Protocol.YATUNG_API_ROOT}/standardV2/informAndFineRecord/factory`; // 查詢罰款紀錄
  public static readonly ChangeTestItemPassStatus: string = `${Protocol.YATUNG_API_ROOT}/standardV2/informAndFineRecord/updateRecheckPass`; // 更改試驗通過狀態
  public static readonly FindAndRejectRecord: string = `${Protocol.YATUNG_API_ROOT}/standardV2/informAndFineRecord/findAndRejectRecord`; // 查詢最新罰款與退料紀錄
  public static readonly UpdateRecheckPass: string = `${Protocol.YATUNG_API_ROOT}/standardV2/informAndFineRecord/updateRecheckPass`; // 更新通過狀態
}
